import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaUserCircle, FaCog, FaPlay, FaDownload } from 'react-icons/fa';
import './PdfUpload.css';
import './videoGeneration.css';
import { generateVideo } from '../../api/api';

const VideoGeneration = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    selectedLessons = [],
    selectedLanguage = '',
    completedSteps = ['Audio Generation'],
    stepFlow = [],
    currentStep = 'Video Generation',
    fileName = '',
    userEmail = 'Eezeelearn@gmail.com',
  } = location.state || {};

  // For storing video URLs and loading states per lesson
  const [videos, setVideos] = useState(
    selectedLessons.map(() => ({
      url: null,
      loading: false,
    }))
  );

  const handleGenerateVideos = async () => {
    const newVideos = [...videos];

    for (let i = 0; i < selectedLessons.length; i++) {
      const lesson = selectedLessons[i];
      const lessonTitle = lesson?.lesson?.title || lesson?.title || '';
      const lessonContent = lesson?.lesson?.content || lesson?.content || '';
      //const lessonId = lesson?.id || lesson?.index || `index_${i}`;
      //const uniqueId = selectedLessons?.[0]?.id || selectedLessons?.[0]?.index || 'dbdc75d9';
      //const uniqueId = lesson?.id || lesson?.index || `index_${i}`; // use THIS lesson's ID

      //const text = `${lessonTitle}\n\n${lessonContent}`;
      //const audioPath = `static/audio/output_${selectedLanguage}_${uniqueId}.mp3`;
      const text = `${lessonTitle}\n\n${lessonContent}`;
      //const audioPath = lesson?.audioPath; // ✅ use actual path returned from backend
      const audioPath = lesson?.audioPath?.replace(/^https?:\/\/[^/]+\/?/, "");// turns "https://eezeelearn.in/static/audio/output_hi_xxx.mp3" // into "static/audio/output_hi_xxx.mp3" 
      const mode = 'single'; // or 'scene' based on selectedOptions if needed

      newVideos[i].loading = true;
      setVideos([...newVideos]);

      try {
        const videoURL = await generateVideo(mode, audioPath, text);
        newVideos[i] = {
          url: videoURL,
          loading: false,
        };
      } catch (error) {
        console.error(`Error generating video for lesson ${i}:`, error);
        newVideos[i] = {
          url: null,
          loading: false,
        };
      }

      setVideos([...newVideos]);
    }
  };

  const handleDownload = (videoUrl, index) => {
    const link = document.createElement('a');
    link.href = videoUrl;
    link.download = `generated-video-${index + 1}.mp4`;
    link.click();
  };

  const handleSignOut = () => {
    navigate('/signin');
  };

  return (
    <div className="page-container">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="sidebar-profile">
          <FaUserCircle className="sidebar-profile-icon" />
          <div className="sidebar-profile-name">{userEmail}</div>
        </div>

        <div className="sidebar-menu">
          <div className="sidebar-item">My Projects</div>
          <div className="sidebar-item" onClick={() => navigate('/upload')}>New Project</div>
          <div className="sidebar-section">
            <div className="sidebar-item section-title">{fileName}</div>
            <div className="sidebar-submenu">
              <div className="sidebar-subitem completed">PDF Upload</div>
              {stepFlow.map((step, idx) => (
                <div
                  key={idx}
                  className={`sidebar-subitem enabled
                    ${completedSteps.includes(step) ? 'completed' : ''}
                    ${step === currentStep ? 'current-step' : ''}`}
                >
                  {step}
                </div>
              ))}
            </div>
          </div>
          <div className="sidebar-item">
            <FaCog style={{ marginRight: '8px' }} /> Settings
          </div>
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>

      {/* Main Content */}
      <div className="video-gen-container">
        <h2>Video Generation</h2>

        <button className="btn" onClick={handleGenerateVideos}>
          <FaPlay /> Generate Video{selectedLessons.length > 1 ? 's' : ''}
        </button>

        <div className="video-grid">
          {selectedLessons.map((lesson, index) => {
            const title = lesson?.lesson?.title || lesson?.title || `Lesson ${index + 1}`;
            const { url, loading } = videos[index] || {};
            return (
              <div key={index} className="video-card">
                <h4>{title}</h4>
                <div className="video-preview-box">
                  {loading ? (
                    <div className="video-placeholder">Generating...</div>
                  ) : url ? (
                    <video controls src={url} className="video-player" />
                  ) : (
                    <div className="video-placeholder">No video generated</div>
                  )}
                </div>
                <button
                  className="btn"
                  onClick={() => handleDownload(url, index)}
                  disabled={!url}
                >
                  <FaDownload /> Download
                </button>
              </div>
            );
          })}
        </div>

        <div className="footer-buttons">
          <button className="action-btn" onClick={() => navigate(-1)}>Back</button>
        </div>
      </div>
    </div>
  );
};

export default VideoGeneration;
